import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles, type Article, type ArticleLocale } from '@/data/articles';

function pickLocale(article: Article, lang: string): ArticleLocale {
  if (lang === 'pl') return article.pl;
  if (lang === 'es') return article.es;
  if (lang === 'fr') return article.fr;
  return article.en;
}

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-stone-900 md:text-3xl">{t('articles.title')}</h2>
          <p className="mt-3 text-sm text-stone-500 md:text-base">{t('articles.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((article) => {
            const locale = pickLocale(article, lang);
            return (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group flex flex-col rounded-lg border border-stone-200 bg-white p-5 hover:border-emerald-300 cursor-pointer"
              >
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-100 text-emerald-700">
                    <i className="ri-file-text-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
                  </span>
                  <span className="text-xs font-semibold uppercase tracking-wide text-emerald-700">
                    {locale.tag}
                  </span>
                </div>
                <h3 className="mt-3 text-base font-semibold leading-snug text-stone-900 group-hover:text-emerald-700">
                  {locale.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-stone-500 line-clamp-3">{locale.description}</p>
                <span className="mt-4 flex items-center gap-1 text-sm font-semibold text-emerald-700 whitespace-nowrap">
                  {t('articles.readMore')}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}